module.exports = __webpack_public_path__ + "img/logo.442f31fa.png";